export default __webpack_public_path__ + "static/media/TROPH.98c14a63.jpg";